import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SedsLoadersBarComponent } from './seds-loaders-bar.component';
import { SedsLoadersCoreModule } from '../../seds-loaders/seds-loaders-core/seds-loaders.module';

@NgModule({
  declarations: [SedsLoadersBarComponent],
  imports: [CommonModule, SedsLoadersCoreModule],
  exports: [SedsLoadersBarComponent],
})
export class SedsLoadersBarModule {}
